import { __assign, __makeTemplateObject, __rest } from "tslib";
import React from 'react';
import styled from '@marvelapp/styled';
import { Text } from '@marvelapp/ui';
import { PencilWrap } from './PencilWrap';
var TextElement = styled(Text)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  word-break: break-word;\n  &:hover {\n    ", " {\n      opacity: 1;\n    }\n  }\n"], ["\n  word-break: break-word;\n  &:hover {\n    ", " {\n      opacity: 1;\n    }\n  }\n"])), PencilWrap);
export default function ProjectNameText(_a) {
    var children = _a.children, kind = _a.kind, props = __rest(_a, ["children", "kind"]);
    return (React.createElement(TextElement, __assign({ borderRadius: 1, color: "licorice", display: "inline-block", hoverBoxShadow: kind === 'light' ? 'input.default' : 'input.whiteTransparentHover', ml: -10, pb: "2px", position: "relative", pt: "2px", px: 10, transitionDuration: "150ms" }, props), children));
}
var templateObject_1;
